import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  title: {
    id: 'studio.4WFkRW',
    defaultMessage: 'Register new account',
  },
  description: {
    id: 'studio.NIoeCv',
    defaultMessage: 'Register a new Appsemble account',
  },
});
